export default __webpack_public_path__ + "static/media/icon-return-air-temp.bf5dce17.svg";